import React from "react";
import { useTranslation } from "react-i18next";
import NumberStatsCard from "../shared/NumberStatsCard";

interface Props {
  title: React.ReactNode;
  description: React.ReactNode;
  color: string;
  icon: string;
  verifiedAmount: number;
  verifiedCount: number;
  pendingCount: number;
  currency: string;
  isLoading: boolean;
  hasLoaded: boolean;
}

export default function BillingTotalStatsCard({ verifiedAmount, verifiedCount, pendingCount, currency, hasLoaded, description, ...props }: Props) {
  const { t } = useTranslation("dashboard", { keyPrefix: "upcomingCharges" });
  const displayValue = !hasLoaded ? t("summaryUnavailable") : pendingCount > 0 ? t("validationPending") : undefined;
  const details = !hasLoaded ? t("summaryUnavailableDescription") : pendingCount > 0 ? <>
    {verifiedCount > 0 && <span className="d-block">{t("verifiedSubtotal", {
      amount: new Intl.NumberFormat("es-ES", { style: "currency", currency }).format(verifiedAmount),
    })}</span>}
    <span className="d-block">{t("amountsPending", { count: pendingCount })}</span>
  </> : description;

  return <NumberStatsCard {...props} isDark={true} number={verifiedAmount} prefix={currency === "EUR" ? "€" : `${currency} `}
    displayValue={displayValue} description={details} />;
}
